import React, { PureComponent } from "react";
import * as styles from "../styles/components/MobileImageContainer.css";
import mobileImg from "../assets/iPhone.png";

export default class MobileImageContainer extends PureComponent {
    render() {
        const { children } = this.props;
        return (
            <div className={styles.mobileImgContainer}>
                <img src={mobileImg} />
                <div className={styles.screen}>{children}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MobileImageContainer.js